import React, { useState } from 'react';
import CountUp from 'react-countup';
import VisibilitySensor  from "react-visibility-sensor";

const NumberAnimate = ({ prefix, suffix, delay, duration, decimals, nb, tspan }, isVisible) => {
	const [ visibility, setVisibility ] = useState(false);
	const Count = ({countUpRef}) => tspan && tspan ? <tspan ref={countUpRef} /> :  <span ref={countUpRef} />
	return (
			<CountUp
				start={visibility ? 0 : null}
				end={nb}
				delay={delay ? delay : 0}
				duration={ duration ? duration : 2.75}
				separator=" "
				decimals={decimals ? decimals : 0}
				decimal=","
				prefix={ prefix ? prefix : ''}
				suffix= {suffix}
			>
					{ 
					({ countUpRef }) => (
						
						<VisibilitySensor onChange={(isVisible) => { 
								setVisibility(isVisible)
							}}
						>
							<Count countUpRef={ countUpRef } />
						</VisibilitySensor>
					)}
			</CountUp>
	);

}
export default NumberAnimate;